/* eslint-disable no-console */

import useTranslations from '~/components/translation/use-translations';
import { isTextKey } from '../my-notifications-utils';
import { useEffect, useState } from 'react';

const usePreprocess = notification => {
	const [data, setData] = useState(notification);
	const retNotification = structuredClone(notification);
	const { ctaText, ctaUrl, image, title, subtitle, description, optixRecommendationType } = retNotification;
	const textkeys = [];

	const addIfTextKey = text => {
		if (isTextKey(text)) textkeys.push(text);
	};

	addIfTextKey(ctaText);
	addIfTextKey(title);
	addIfTextKey(subtitle);
	addIfTextKey(description);

	if (retNotification?.data) {
		try {
			// retNotification.data = JSON.parse(retNotification.data);
			const { Accordion } = retNotification.data;
			if (Accordion) {
				// eslint-disable-next-line camelcase
				const { accordion_title, accordion_content } = Accordion;
				addIfTextKey(accordion_title);
				addIfTextKey(accordion_content);
			}
		} catch (e) {
			console.error('Data parse error on notification id: #%d', retNotification.id);
		}
	}

	if (retNotification?.notificationPopUp) {
		const { title: popupTitle, subtitle: popupSubtitle, ctaText: popupCtaText } = retNotification.notificationPopUp;

		addIfTextKey(popupTitle);
		addIfTextKey(popupSubtitle);
		addIfTextKey(popupCtaText);

		if (retNotification.notificationPopUp?.data) {
			try {
				retNotification.notificationPopUp.data = JSON.parse(retNotification.notificationPopUp.data);
				const { PopupAdditionalData } = retNotification.notificationPopUp.data;
				if (PopupAdditionalData) {
					const { title: popupAdditionalDataTitle, content: popupAdditionalDataContent } =
						PopupAdditionalData;

					addIfTextKey(popupAdditionalDataTitle);
					addIfTextKey(popupAdditionalDataContent);
				}
			} catch (e) {
				console.error('Data parse error on notification popup id: #%d', retNotification.notificationPopUp.id);
			}
		}
	}

	const { translations, isLoadingTranslations } = useTranslations(textkeys);

	const placeholders = Array.from(Object.entries(retNotification?.personalizationData || {}));
	// currently only using the first element in the recommendations array
	// /%@optixCasinoGameCode[0-9]+%/gm regex can be used to match placeholders with index accessors
	// e.g. %@optixCasinoGameCode0%
	// replace 2nd element in the placeholders array with a function
	// to access and return the correct index element in the future
	if (optixRecommendationType === 'casino') {
		const optixCasinoRecommendations = retNotification.personalizationData?.recommendations[0].result;
		const optixCasinoPlaceholders = [
			['optixCasinoUrlShortcutVerb', optixCasinoRecommendations[0]?.extra?.urlShortcutVerb],
			['optixCasinoImageUrl', optixCasinoRecommendations[0].imageURL],
			['optixCasinoName', optixCasinoRecommendations[0].name]
		];
		placeholders.push(...optixCasinoPlaceholders);
	}
	// currently only using the first element in the recommendations array
	if (optixRecommendationType === 'sportsbook') {
		const optixSportsbookRecommendations = retNotification.personalizationData?.recommendations[0].result;
		const optixSportsbookPlaceholders = [
			['optixSportsbookEventName', optixSportsbookRecommendations[0].eventName],
			['optixSportsbookEventDateTime', optixSportsbookRecommendations[0].eventDateTime],
			['optixSportsbookDecPrice', optixSportsbookRecommendations[0].decPrice],
			['optixSportsbookMinsToOff', optixSportsbookRecommendations[0].minsToOff],
			['optixSportsbookEventKey', optixSportsbookRecommendations[0].eventKey],
			['optixSportsbookSelectionKey', optixSportsbookRecommendations[0].selectionKey],
			['optixSportsbookSelectionName', optixSportsbookRecommendations[0].selectionName]
		];
		placeholders.push(...optixSportsbookPlaceholders);
	}

	useEffect(() => {
		const replacePlaceholders = text => {
			if (!text) {
				return text;
			}
			let ret = isTextKey(text) ? translations[text] : text;

			if (placeholders.length === 0) {
				return ret;
			}

			placeholders.forEach(placeholder => {
				// replace the placeholder with the corresponding value
				// ONLY IF there is a value
				if (placeholder[1]) {
					ret = ret.replaceAll(`%@${placeholder[0]}%`, placeholder[1]);
				}
			});

			return ret;
		};

		if (!isLoadingTranslations) {
			retNotification.ctaText = replacePlaceholders(ctaText);
			retNotification.ctaUrl = replacePlaceholders(ctaUrl);
			retNotification.image = replacePlaceholders(image);
			retNotification.title = replacePlaceholders(title);
			retNotification.subtitle = replacePlaceholders(subtitle);
			retNotification.description = replacePlaceholders(description);

			if (retNotification?.data?.Accordion) {
				// eslint-disable-next-line camelcase
				const { accordion_title, accordion_content } = retNotification.data.Accordion;

				retNotification.data.Accordion.accordion_title = replacePlaceholders(accordion_title);
				retNotification.data.Accordion.accordion_content = replacePlaceholders(accordion_content);
			}

			if (retNotification?.notificationPopUp) {
				const { notificationPopUp } = retNotification;
				const {
					title: popupTitle,
					subtitle: popupSubtitle,
					image: popupImage,
					ctaText: popupCtaText,
					ctaUrl: popupCtaUrl
				} = notificationPopUp;

				notificationPopUp.title = replacePlaceholders(popupTitle);
				notificationPopUp.subtitle = replacePlaceholders(popupSubtitle);
				notificationPopUp.image = replacePlaceholders(popupImage);
				notificationPopUp.ctaText = replacePlaceholders(popupCtaText);
				notificationPopUp.ctaUrl = replacePlaceholders(popupCtaUrl);

				if (notificationPopUp?.data?.PopupAdditionalData) {
					const { PopupAdditionalData } = retNotification.notificationPopUp.data;
					const { title: popupAdditionalDataTitle, content: popupAdditionalDataContent } =
						PopupAdditionalData;
					PopupAdditionalData.title = replacePlaceholders(popupAdditionalDataTitle);
					PopupAdditionalData.content = replacePlaceholders(popupAdditionalDataContent);
				}
			}
			setData(retNotification);
		}
		// eslint-disable-next-line react-hooks/exhaustive-deps
	}, [isLoadingTranslations]);

	return data;
};

export default usePreprocess;
